import React from 'react';

import { Select, SelectProps } from '@mantine/core';
import { Country } from 'types/enums';

export const COUNTRIES: Array<{ label: string; value: Country }> = [
  { value: 'US', label: 'United States' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'CA', label: 'Canada' },
];

const CountryAutoComplete = ({ ...acProps }: Omit<SelectProps, 'data'>): JSX.Element => {
  return <Select data={COUNTRIES} placeholder='Select Country' label='Country' searchable {...acProps} />;
};

export default CountryAutoComplete;
